import React from 'react';
import ReactRouter from 'react-router';
import { SupplierDirectoryType } from '@ordermentum/ui-types';
import Spinner from '@ordermentum/ui-shared/atoms/Spinner';
import C from '@ordermentum/ui-constants';
import {
  ChildContent,
  HeaderContainer,
  HeaderImage,
  HeaderTitle,
  LogoContainer,
  OrdermentumLogo,
  PoweredByText,
  PoweredContainer,
  SplashHeading,
  SplashImage,
} from './LoginBase.styles';
import { RouteParams } from './Forms/index.types';
import AccountPage from './SignUpFlow';

export const SupplierHeader = ({
  supplier,
}: {
  supplier?: SupplierDirectoryType;
}) => (
  <HeaderContainer>
    {supplier && (
      <>
        <LogoContainer>
          {supplier.logo?.small && <HeaderImage src={supplier.logo?.small} />}
          <HeaderTitle>{supplier.tradingName}</HeaderTitle>
        </LogoContainer>
        <PoweredContainer>
          <PoweredByText>powered by</PoweredByText>
          <OrdermentumLogo src={`${C.IMAGE_URL}/logo-ordermentum-full.svg`} />
        </PoweredContainer>
      </>
    )}
  </HeaderContainer>
);

export const SupplierContent = ({
  supplier,
}: {
  supplier?: SupplierDirectoryType;
}) => (
  <ChildContent>
    {!supplier ? (
      <Spinner size="xxl" />
    ) : (
      <>
        {supplier.brandImages !== undefined &&
          supplier.brandImages.length !== 0 && (
            <SplashImage src={supplier.brandImages[0].medium} />
          )}
        <SplashHeading>
          Ordermentum makes it easy to order from {supplier.tradingName}
        </SplashHeading>
        <p>{supplier.supplierQuote}</p>
      </>
    )}
  </ChildContent>
);

export const MagicLinkLogin = (
  props: ReactRouter.RouteComponentProps<RouteParams, {}>
) => {
  const {
    params: { supplierId = '', retailerId = '' },
  } = props;

  return <AccountPage supplierId={supplierId} retailerId={retailerId} />;
};
